function removeItem(name: string) {
  return window.localStorage.removeItem(name);
}

export function getItem(name: string, format?: null | string) {
  const item = window.localStorage.getItem(name);
  if (format === 'json') {
    return JSON.parse(item || '{}');
  }
  return item;
}

function setItem(name: string, value: any, format?: null | string) {
  let v = value;
  if (format === 'json') {
    v = JSON.stringify(v);
  }
  window.localStorage.setItem(name, v);
  return true;
}

export function setSsoNext(url: string) {
  setItem('sso_next', url);
}

export function clearSsoNext() {
  removeItem('sso_next');
}
export function getSsoNext() {
  return getItem('sso_next');
}
